// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__90Pis","log":"ModalInventoryLogs_log__K-y52","date":"ModalInventoryLogs_date__2J6PS","userName":"ModalInventoryLogs_userName__32QiO"};